import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { RxDashboard } from 'react-icons/rx'
import { FiUsers, FiUser, FiLogOut, FiShield, FiHeadphones, FiInbox, FiSend } from 'react-icons/fi'
import { BiCategory } from 'react-icons/bi'
import { FaBarsStaggered } from 'react-icons/fa6'
import { PiPassword } from 'react-icons/pi'
import { MdDoubleArrow } from 'react-icons/md'
import { AppContext } from '../contexts/AppContext'
import { PiUserCircleLight } from 'react-icons/pi'
// import { IoSettingsOutline } from 'react-icons/io5'
import { MdOutlineAnalytics } from 'react-icons/md'
import { LuSettings2 } from 'react-icons/lu'
import { HiOutlineDocumentReport } from 'react-icons/hi'
// import { AuthContext } from '../contexts/AuthContext'

// One sidebar entry: full label when expanded, icon only when collapsed
const NavItem = ({ to, icon: Icon, label, active = false, onClick }) => (
  <Link
    to={to}
    className={`nav-main ${active ? 'active-link' : ''}`}
    onClick={onClick}
  >
    <div className='nav-hide'>
      <Icon /> {label}
    </div>
    <div className='nav-icon'>
      <Icon />
    </div>
  </Link>
)

const AppLayout = ({ children, pageName }) => {
  const navigate = useNavigate()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const sidebarRef = useRef(null)
  const { userToken, logout } = useContext(AppContext)
  // const { userToken } = useContext(AuthContext);
  const isGuestUser =
    !!userToken &&
    (userToken.is_guest === 1 || userToken.is_guest === true || userToken.isGuest === 1 || userToken.isGuest === true)

  useEffect(() => {
    if (userToken === null) {
      navigate('/')
    }
  }, [navigate, userToken])

  const handleLogout = async () => {
    const response = await logout()
    if (response === 'success') {
      navigate('/')
    }
  }

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  //   // Callback ref to ensure we get the latest node
  //   const setSidebarRef = useCallback((node) => {
  //     sidebarRef.current = node;
  //   }, []);

  //   useEffect(() => {
  //     // Function to check if clicked outside of sidebar
  //     const handleClickOutside = (event) => {
  //       alert("test");
  //       if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
  //         setIsSidebarOpen(false);
  //       }
  //     };

  //     // Add event listener
  //     document.addEventListener("mousedown", handleClickOutside);

  //     // Clean up
  //     return () => {
  //       document.removeEventListener("mousedown", handleClickOutside);
  //     };
  //   }, [sidebarRef]);

  return (
    <>
      {userToken !== null ? (
        <div
          className={`d-flex ${isSidebarOpen ? 'toggled' : ''}`}
          id='wrapper'
          ref={sidebarRef}
        >
          <div
            id='sidebar-wrapper'
            className='my-2 top-0'
          >
            <div className='sidebar-heading'>
              <img
                src='/images/icons/pocketfm-icon.svg'
                className='w-9 logo-sm'
                alt='Pocket FM'
              />
              <img
                src='/images/icons/pocketfm-logo.svg'
                className='p-0 logo'
                alt='Pocket FM'
              />
              <button
                className='btn'
                onClick={handleSidebarToggle}
                id='menu-toggle'
              >
                <MdDoubleArrow
                  color='#FFF'
                  size={42}
                />
              </button>
            </div>
            <div className='list-group list-group-flush pt-1.5 pb-3'>
              {isGuestUser ? (
                <div className='w-100'>
                  <div className='px-2 d-flex'>
                    <NavItem to='/report-infringement' icon={HiOutlineDocumentReport} label='Report Infringement' active={pageName === 'Report Infringement'} />
                    <NavItem to='/' icon={FiLogOut} label='Logout' onClick={handleLogout} />
                  </div>
                </div>
              ) : (
                <>
                  <div className='w-100'>
                    <div className='px-2 d-flex'>
                      <NavItem to='/dashboard' icon={RxDashboard} label='Home' active={pageName === 'Home'} />
                      <NavItem to='/overview' icon={MdOutlineAnalytics} label='Overview' active={pageName === 'Overview'} />
                      <NavItem to='/report' icon={HiOutlineDocumentReport} label='Period Reports' active={pageName === 'Period Reports'} />
                      {userToken.type === 'Admin' && (
                        <>
                          <NavItem
                            to='/all-matches'
                            icon={FiHeadphones}
                            label='Works'
                            active={['All Works', 'Work Details', 'Add New Work', 'Update Work'].includes(pageName)}
                          />
                          <NavItem to='/competitions' icon={BiCategory} label='Categories' active={pageName === 'All Categories'} />
                          <NavItem
                            to='/all-members'
                            icon={FiUsers}
                            label='Members'
                            active={['All Members', 'Add New Member', 'Update Member'].includes(pageName)}
                          />
                          <NavItem
                            to='/all-admins'
                            icon={FiUsers}
                            label='Admins'
                            active={['All Admins', 'Add New Admin', 'Update Admin'].includes(pageName)}
                          />
                          <NavItem to='/infringing-urls' icon={FiInbox} label='Reported URLs' active={pageName === 'Reported URLs'} />
                        </>
                      )}
                      {userToken.type === 'Member' && (
                        <>
                          <NavItem to='/matches' icon={FiHeadphones} label='Works' active={['Works', 'Work Details'].includes(pageName)} />
                          <NavItem
                            to='/report-infringement'
                            icon={FiSend}
                            label='Report Infringement'
                            active={pageName === 'Report Infringement'}
                          />
                        </>
                      )}
                      <NavItem to='/allow-listed-accounts' icon={FiShield} label='Allow List' active={pageName === 'Allowlist'} />
                    </div>
                    <div className='border-top px-2 d-flex'>
                      <br />
                      <p>
                        <i className='fas fa-minus fa-sm'></i>&nbsp; My Account
                      </p>
                      <NavItem to='/profile' icon={FiUser} label='My Account' active={pageName === 'My Account'} />
                      <NavItem to='/change-password' icon={PiPassword} label='Change Password' active={pageName === 'Change Password'} />
                    </div>
                  </div>
                  <div className='w-100'>
                    <div className='border-top px-2 d-flex'>
                      <br />
                      {userToken.type === 'Admin' && (
                        <>
                          <NavItem to='/edit-matchday-data' icon={LuSettings2} label='Period Data' active={pageName === 'Period Data'} />
                          <NavItem to='/edit-websites-links' icon={LuSettings2} label='Platforms' active={pageName === 'Platforms'} />
                        </>
                      )}
                      <NavItem to='/' icon={FiLogOut} label='Logout' onClick={handleLogout} />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          <div
            id='page-content-wrapper'
            className='flex flex-col'
          >
            <div className='flex-1 shrink-0 p-2'>
              <nav className='navbar navbar-expand-lg bg-pfm-dark flex items-center'>
                <span
                  id='menu-toggle-sm'
                  onClick={handleSidebarToggle}
                >
                  <FaBarsStaggered
                    color='#FFF'
                    size={22}
                  />
                </span>
                <div className='page-head ml-3'>
                  <h4>{pageName !== '' ? pageName : ''}</h4>
                </div>
                <div className='ml-auto max-sm:hidden'>
                  <div className='btn-nav-user'>
                    <PiUserCircleLight size={44} />
                    <div>
                      <h6>{userToken.name}</h6>
                      <Link
                        to='/'
                        onClick={handleLogout}
                      >
                        Logout
                      </Link>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
            <div className='content-scrollable'>{children}</div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  )
}

export default AppLayout
